/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index dropdown to autogenerate all the components and extensions
 * Used by "prepareDropdowns"
 */

import Dropdown from './dropdown/Dropdown'
export * from './dropdown/Dropdown'
export default Dropdown
